/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />
/// <reference path = "../../node_modules/@types/select2/index.d.ts" />

import listenForClick from "./clickHandler";

let select2Instances : any[] = [];

function getSiblings (elem : HTMLElement) {

	// Setup siblings array and get the first sibling
	let siblings = [] as HTMLElement[];
	let sibling = elem.parentNode.firstElementChild as HTMLElement;

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextElementSibling as HTMLElement
	}

	return siblings;

};

function setSbilingsClass(elem : HTMLElement, className : string, isAdd : boolean){
	let siblings = getSiblings(elem);

	siblings.forEach(sibling => {
		if (isAdd)
			sibling.classList.add(className);
		else
			sibling.classList.remove(className);
	});
}

const closedClass = "mi-closed";

// Toggle the sibling.
export function handleToggleSibling(){
	let allToggleHeader = document.querySelectorAll(".mi-toggle-sibling");

	allToggleHeader.forEach(_header => {
		let header = _header as HTMLElement;
		if (header.classList.contains("mi-skip-toggle"))
			return;

		let updateSiblings = () => {
			setSbilingsClass(header, "mi-hidden", header.classList.contains(closedClass));
		}
		updateSiblings();

		listenForClick(header, () => {
			if (header.classList.contains(closedClass))
				header.classList.remove(closedClass);
			else
				header.classList.add(closedClass);

			updateSiblings();
		});

		let handleResize = () => {
			let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (screenWidth > 1024)
				setSbilingsClass(header, "mi-hidden", false);
			else
				updateSiblings();
		}

		handleResize();
		window.addEventListener("resize", handleResize);
	});
}

// If the section has no slide, then no drop shadow.
export function handleRelatedProducts(){
	if (!(window as any).mi_isSingleProductPage)
		return;

	let slides = document.querySelectorAll(".mi-single-product-slide");
	if (slides.length == 0)
		return;

	let relatedProductColumn = document.querySelector(".mi-related-products-column") as HTMLElement;
	if (relatedProductColumn)
		relatedProductColumn.classList.add("has-data"); // Then the section shows a drop shadow only if it has slides.
}

// move the tags div to buttom.
export function adjustPostTags(){
	let postGrids = document.querySelectorAll(".mi-posts");
	
	postGrids.forEach(_postGrid => {
		let postGrid = _postGrid as HTMLElement;

		let eachPosts = postGrid.querySelectorAll(".uael-post__content-wrap");

		eachPosts.forEach(_eachPost => {
			let eachPost = _eachPost as HTMLElement;

			let tagsWrapper = eachPost.querySelector(".uael-post__terms-meta-tag") as HTMLElement;

			if (tagsWrapper)
				eachPost.appendChild(tagsWrapper);
		});
	});
}

// Find the first form as anchor target of request button
// Assume the first form is the request quoation form.
// Find the anchor is better, as after submission, the anchor is still valid.
export function getFirstFormAnchorID(){
	let firstForm = document.querySelector(".gform_wrapper .gform_anchor") as HTMLElement;
	if (firstForm)
		return "#" + firstForm.id;
	else
		return null;
}

export function removeLastSlashFromBreadcrumb(){
	let allbreadcrumbs = document.querySelectorAll(".woocommerce-breadcrumb");
	allbreadcrumbs.forEach(_crumb => {
		let crumb = _crumb as HTMLElement;
		let lastChild = crumb.lastChild;
		let lastChildContent = (lastChild as any).data as string;
		//console.log(lastChildContent);
		if (lastChildContent && lastChildContent.trim() == "/"){
			lastChild.remove();
		}
	});
}

export function handleTopBigSearchAndSearchPopupButton(subClass : string){
	//console.log("handleTopBigSearchAndSearchPopupButton of: " + subClass);

	let bigSearchWrappers = document.querySelectorAll(".mi-search-big-wrapper." + subClass);
	bigSearchWrappers.forEach(_bigSearchWrapper => {
		let bigSearchWrapper = _bigSearchWrapper as HTMLElement;
		if (!bigSearchWrapper.dataset.miProcessed){
			bigSearchWrapper.dataset.miProcessed = "processed";

			{
				// use to update the form's action:
				let form = bigSearchWrapper.querySelector("form") as HTMLFormElement;
				if (!form)
					console.error("Missing form element");


				// Change to select2 drop down.
				let dropdowns = bigSearchWrapper.querySelectorAll(".mi-simple-dropdown");
				dropdowns.forEach(_dropdown => {
					let dropdown = _dropdown as HTMLSelectElement;

					let instance = jQuery(dropdown).select2({
						minimumResultsForSearch: -1,
						selectionCssClass: "mi-search-big-cat-dd",
						dropdownCssClass: "mi-simple-dropdown-content mi-upper",
						width: "145px"
					} as any) as any as JQuery<HTMLElement>;

					select2Instances.push(instance);

					let updateFormAction = (selectEle : HTMLSelectElement) => {
						let selectedValue = selectEle.options[selectEle.selectedIndex].value;
						//console.log(selectedValue);
						form.action = selectedValue;
					}
					updateFormAction(dropdown);
					
					instance.on("change.select2", (event : Event) => {
						updateFormAction(event.currentTarget as HTMLSelectElement);
					});
				});
			}

			{
				// when click on the frequent search words, update the input field.

				let input = bigSearchWrapper.querySelector("input") as HTMLInputElement;
				let searchButton = bigSearchWrapper.querySelector("button.elementor-search-form__submit") as HTMLButtonElement;

				let searchTermList = bigSearchWrapper.querySelector(".mi-top-search-list");
				searchTermList.childNodes.forEach(_searchTerm => {
					if (_searchTerm.nodeName == "DIV"){
						let searchTerm = _searchTerm as HTMLDivElement;
						if (!searchTerm.classList.contains("heading")){
							listenForClick(searchTerm, () => {
								input.value = searchTerm.textContent;
								searchButton.click();
							});
						}
					}
				});
			}

			{
				// Elementor cannot set the popup close by clicking on the overlay background.
				// So I add a div on top of the overlay area and mimic click on the original close button.
				let popup = document.querySelector(".mi-search-popup");

				if (popup){
					let emptyDiv = popup.querySelector(".mi-dialog-empty-space") as HTMLElement;
					if (!emptyDiv){
						let closeButton = popup.querySelector(".dialog-close-button") as HTMLElement;
						let message = popup.querySelector(".dialog-message") as HTMLElement;

						emptyDiv = document.createElement("div");
						emptyDiv.classList.add("mi-dialog-empty-space");
						listenForClick(emptyDiv, () => {
							closeButton.click();

							// When the dialog close, should close the select2's popup.
							select2Instances.forEach(instance => {
								instance.select2('close');
							});
						});

						message.appendChild(emptyDiv);
					}
				}
			}
		};
	});
}

export function delayShowMobileMagnifyGlass(){
	// don't know why, the magnify glass popup big when page load.
	// so add a delay to show it.
	let glasses = document.querySelectorAll(".mi-magnify-glass");
	glasses.forEach(_glass => {
		let glass = _glass as HTMLSelectElement;
		glass.classList.remove("mi-hidden");
	});
}

export function handleProductFilterDropdown(){
	let dropdowns = document.querySelectorAll(".mi-prod-cat-select");
	dropdowns.forEach(_dropdown => {
		let dropdown = _dropdown as HTMLSelectElement;

		let instance = jQuery(dropdown).select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: "mi-simple-dropdown-content",
			width: "50%"
		} as any) as any as JQuery<HTMLElement>;
		// container class added by this.
		(dropdown.nextElementSibling as HTMLElement).classList.add("mi-prod-cat-dd-wrapper");

		select2Instances.push(instance);

		let handleClick = (selectEle : HTMLSelectElement) => {
			let url = selectEle.options[selectEle.selectedIndex].value;
			window.location.href = url;
		}
		
		instance.on("change.select2", (event : Event) => {
			handleClick(event.currentTarget as HTMLSelectElement);
		});
	});	
}

export function handleWooCommSortByDropdown(){
	let dropdowns = document.querySelectorAll(".woocommerce-ordering select");
	dropdowns.forEach(_dropdown => {
		let dropdown = _dropdown as HTMLSelectElement;

		let instance = jQuery(dropdown).select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: "mi-simple-dropdown-content",
			width: "100%"
		} as any) as any as JQuery<HTMLElement>;
		// container class added by this.
		(dropdown.nextElementSibling as HTMLElement).classList.add("mi-woo-ordering-dd-wrapper");

		select2Instances.push(instance);
	});	
}

export function handleSimpleToggle(){
	let marketValues : string[];
	{
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const marketValue = urlParams.get("market") ?? '';
		marketValues = marketValue.split("~");
	}

	let target = ".mi-checkbox-wrapper .container";
	let checkboxes = document.querySelectorAll(target);
	checkboxes.forEach(_checkbox => {
		let checkbox = _checkbox as HTMLSelectElement;

		if (marketValues.indexOf(checkbox.dataset.value) != -1)
			checkbox.classList.add("mi-selected");

		listenForClick(checkbox, () => {
			checkbox.classList.toggle("mi-selected");

			// grab the selected market checkbox, combine to new query and pass query to server.
			let selectedCheckboxes = document.querySelectorAll(target + ".mi-selected");
			let selectedValues: string[] = [];
			selectedCheckboxes.forEach(_innerCheckbox => {
				let innerCheckbox = _innerCheckbox as HTMLElement;
				selectedValues.push(innerCheckbox.dataset.value);
			})

			const queryString = window.location.search;
			//console.log(queryString);
			const urlParams = new URLSearchParams(queryString);
			const marketValue = selectedValues.join("~");
			urlParams.delete("paged"); // Better remove page param.
			urlParams.set("market", marketValue);
			//console.log(urlParams.toString());
			let oldUrlNoQueryString = window.location.href.split("?")[0];
			let oldUrlSplitted = oldUrlNoQueryString.split("/");
			//console.log(oldUrlSplitted);
			
			let checkPos = 2;
			if (oldUrlSplitted.length > 1 && oldUrlSplitted[oldUrlSplitted.length - 1] == ""){
				checkPos++;
			}
			if (oldUrlSplitted.length > checkPos){
				if (oldUrlSplitted[oldUrlSplitted.length - checkPos] == "page"){
					while(checkPos > 0){
						oldUrlSplitted.pop()
						checkPos--;
					}

					oldUrlNoQueryString = oldUrlSplitted.join("/") + "/";
				}
			}

			let newUrl = oldUrlNoQueryString + "?" + urlParams.toString();
			//console.log(newUrl);
			window.location.href = newUrl;
		});
	});
}

export function moveAboutUsServiceCategories(){
	//console.log("moveAboutUsServiceCategories");

	const attribute = "data-mi-move-these-wrapper";

	let moveHeres = document.querySelectorAll(".mi-move-here");
	moveHeres.forEach(_moveHere => {
		let moveHere = _moveHere as HTMLElement;
		let slideWrapperItem = moveHere.attributes.getNamedItem(attribute);

		if (!slideWrapperItem){
			console.log("Cannot find the attribute: " + attribute);
			return;
		}

		let slideWrapperId = slideWrapperItem.value;
		let slideWrapper = document.querySelector("#" + slideWrapperId);
		if (!slideWrapper){
			console.log("Cannot find the id: " + slideWrapperId);
			return;
		}

		let slides = slideWrapper.querySelectorAll(".mi-move-these");
		if (slides.length == 0){
			console.log("No slide to move, error?");
			return;
		}

		let parent = moveHere.parentElement as HTMLElement;
		moveHere.remove();
	
		slides.forEach(_slide => {
			let slide = _slide as HTMLElement;
			parent.appendChild(slide);
		})
	
	})
}

export function disableMiniCartOnMobile(){
	let woo_cart = document.querySelector('.ast-mobile-header-wrap .ast-header-woo-cart');
	if (!woo_cart)
		return;

	woo_cart.addEventListener('click', (event) => {
		//event.preventDefault(); // let it open the link.
		event.stopImmediatePropagation(); // prevent theme's action.
	});
}


export function handleMobileMenuItemClick() {
	let popup = document.querySelector("#ast-mobile-popup");

	let allLink = popup.querySelectorAll("a.menu-link");
	allLink.forEach(_link => {
		let link = _link as HTMLAnchorElement;

		link.addEventListener('click', () => {
			window.location.href = link.href;
		});
	});
}

export function hideAllTheseDivs(elements : NodeListOf<Element>){
	elements.forEach(element => {
		(element as HTMLElement).classList.add("mi-hidden");
	});
}

export function setGoogleTag(){

	// My product slides.
	{
		let allSingleProduct = document.querySelectorAll(".mi-single-product-slide");
		allSingleProduct.forEach(_singleProduct => {
			let singleProduct = _singleProduct as HTMLElement;
			let slug = singleProduct.dataset.slug;

			let image = singleProduct.querySelector(".mi-image");
			if (image){
				(image as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productImageClick",
						slug: slug
					});
				});
			}

			let name = singleProduct.querySelector(".mi-name");
			if (name){
				(name as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productNameClick",
						slug: slug
					});
				});
			}

			let price = singleProduct.querySelector(".mi-price");
			if (price){
				(price as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productPriceClick",
						slug: slug
					});
				});
			}

			let reqQuote = singleProduct.querySelector(".mi-request-quote");
			if (reqQuote){
				(reqQuote as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "productReqQuoteClick",
						slug: slug
					});
				});
			}
		});
	}

	// alternative product lists:
	{
		let allSingleProduct = document.querySelectorAll(".elementor-portfolio-item.product");
		allSingleProduct.forEach(_singleProduct => {
			let singleProduct = _singleProduct as HTMLElement;
			let a = singleProduct.querySelector("a") as HTMLAnchorElement;
			let slug = getSlug(a.href);

			let image = singleProduct.querySelector(".elementor-portfolio-item__overlay"); // the overlay cover the whole image, so use this instead of img.
			if (image){
				(image as HTMLElement).addEventListener('click', (e) => {
					console.log("click on overlay: " + (e.target as HTMLElement).nodeName);
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: (e.target as HTMLElement).nodeName == "DIV" ? "productImageClick" : "productNameClick",
						slug: slug
					});
				}, false);
			}

			// let name = singleProduct.querySelector(".elementor-portfolio-item__title");
			// if (name){
			// 	(name as HTMLElement).addEventListener('click', () => {
			// 		(window as any).dataLayer = (window as any).dataLayer || [];
			// 		(window as any).dataLayer.push({
			// 			event: "productNameClick",
			// 			slug: slug
			// 		});
			// 	});
			// }
		});
	}

	// Post lists
	{
		let allPost = document.querySelectorAll(".uael-post-wrapper");
		allPost.forEach(_post => {
			let post = _post as HTMLElement;
			let a = post.querySelector("a") as HTMLAnchorElement;
			let slug = getSlug(a.href);

			let image = post.querySelector(".uael-post__thumbnail");
			if (image){
				(image as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "blogImageClick",
						slug: slug
					});
				});
			}

			let title = post.querySelector(".uael-post__title");
			if (title){
				(title as HTMLElement).addEventListener('click', () => {
					(window as any).dataLayer = (window as any).dataLayer || [];
					(window as any).dataLayer.push({
						event: "blogTitleClick",
						slug: slug
					});
				});
			}
	
		});
	}
}

function getSlug(url:string){
	let parts = url.split('/');
	let slug = parts.pop() || parts.pop();  // handle potential trailing slash

	return slug;
}

export function showProductList() {
	let allProductSlide = document.querySelectorAll(".mi-single-product-slide");
	allProductSlide.forEach(_productSlide => {
		let productSlide = _productSlide as HTMLElement;
		productSlide.classList.remove("mi-invis");
	});	
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Functions for Fung Yuen
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Click the eye icon to toggle showing or hiding password field.
export function handleTogglePassword() {
	const togglePasswordButton = document.querySelector('#togglePassword') as HTMLElement;
	const passwordField = document.querySelector('input[name="password"]') as HTMLInputElement;
	togglePasswordButton.addEventListener('click', () => {
		let type = passwordField.getAttribute('type') === "password" ? "text" : "password";
		passwordField.setAttribute('type', type);
		if (passwordField.getAttribute('type') === "password") {
			togglePasswordButton.classList.remove("fa-eye-slash");
			togglePasswordButton.classList.add("fa-eye");
		} else {
			togglePasswordButton.classList.remove("fa-eye");
			togglePasswordButton.classList.add("fa-eye-slash");
		}
		passwordField.focus();
	})
}

// Handle few things for display on register form
export function handleRegisterFormDisplay() {
	const registerForm = document.querySelector('#fy-register-form');
	if (registerForm) {
		// Set the font color of pre-select value
		const genderField = document.querySelector('#user_gender') as HTMLSelectElement;
		genderField.style.color = "#999999";
		genderField.addEventListener('change', e=> {
			e.preventDefault();
			if (genderField.value != 'defaultPreSelect') {
				genderField.style.color = 'black';
			}
		})
	
		// Click upload button to trigger the upload field
		// const user_id_copy_button = document.querySelector('#user_id_copy_button') as HTMLElement;
		// const user_id_copy_label = document.querySelector('label[for="user_id_copy"]') as HTMLElement;
		// const user_photo_button = document.querySelector('#user_photo_button') as HTMLElement;
		// const user_photo_label = document.querySelector('label[for="user_photo"]') as HTMLElement;
		// user_id_copy_button.addEventListener('click', e => {
			// e.preventDefault();
			// user_id_copy_label.click();
		// });
		// user_photo_button.addEventListener('click', e => {
		// 	e.preventDefault();
		// 	user_photo_label.click();
		// })
	
		// Show the selected file name in the file-input field
		// const user_id_copy_field = document.querySelector('input[name="user_id_copy"]') as HTMLInputElement;
		// const user_photo_field = document.querySelector('input[name="user_photo"]') as HTMLInputElement;
		// user_id_copy_field.addEventListener('change', e => {
			// if (user_id_copy_field.value !== "") {
				// user_id_copy_label.innerText = user_id_copy_field.value;
			// } else {
				// user_id_copy_label.innerText = '香港身份證副本';
			// }
		// })
		// user_photo_field.addEventListener('change', e => {
		// 	if (user_photo_field.value !== "") {
		// 		user_photo_label.innerText = user_photo_field.value;
		// 	} else {
		// 		user_photo_label.innerText = '證件照片';
		// 	}
		// })
	}

}

// When typing the SMS verify code, show "request again" button
export function handleRegisterVerifyButton() {
	// const phoneConfirmInput = document.querySelector('input[name="phone_confirm"]') as HTMLInputElement;
	// const phoneVerifyRequestButton = document.querySelector('#phone-verify-request-button') as HTMLElement;
	// const phoneVerifyButton = document.querySelector('#phone-verify-request-again-button') as HTMLElement;
	// if (phoneConfirmInput) {
	// 	phoneConfirmInput.addEventListener('keyup', e => {
	// 		e.preventDefault();
	// 		if (phoneConfirmInput.value) {
	// 			phoneVerifyRequestButton.classList.add('hidden');
	// 			phoneVerifyButton.classList.remove('hidden');
	// 		} else {
	// 			phoneVerifyRequestButton.classList.remove('hidden');
	// 			phoneVerifyButton.classList.add('hidden');
	// 		}
	// 	} )
	// }
}

// Timer countdown function
function runTimer(intervalID: any) {
	const phoneVerifyTimer = document.querySelector('#phone-verify-timer') as HTMLElement;
	let timeLeft = 300;
	phoneVerifyTimer.innerText = `${String(timeLeft)}s`;
	intervalID = window.setInterval(() => {
		timeLeft--;
		if (timeLeft > 0) {
			// console.log(timeLeft);
			phoneVerifyTimer.innerText = `${String(timeLeft)}s`;
		} else {
			phoneVerifyTimer.innerText = "已無效";
			phoneVerifyTimer.style.color = "red";
			clearInterval(intervalID);
		}
	}, 1000)
	return intervalID;
}

// Send SMS request on register page or cancel and send request again
export function handlePhoneSendSMSRequest() {
	const phoneVerifyRequestButton = document.querySelector('#phone-verify-request-button') as HTMLElement;
	const phoneVerifyRequestAgainButton = document.querySelector('#phone-verify-request-again-button') as HTMLElement;
	const phoneVerifyTimer = document.querySelector('#phone-verify-timer') as HTMLElement;
	const smsRequest = document.querySelector('input[name="smsRequest"]') as HTMLInputElement;
	const phoneNumberField = document.querySelector('input[name="phone_number"]') as HTMLInputElement;
	phoneNumberField.addEventListener('keyup', e => {
		e.preventDefault();
		let length = phoneNumberField.value.length;
		// console.log(length);
		// if (length == 8) {
		// 	phoneVerifyRequestButton.classList.remove('disable-button');
		// } else {
		// 	phoneVerifyRequestButton.classList.add('disable-button');
		// }
	})

	let intervalID:any;

	// Event listener for handling create SMS request
	if (phoneVerifyRequestButton) {
		listenForClick(phoneVerifyRequestButton, () => {
			// timer countdown
			phoneVerifyRequestButton.classList.add('hidden');
			phoneVerifyRequestAgainButton.classList.remove('hidden');
			phoneVerifyTimer.classList.remove('hidden');
			// phoneVerifyTimer.style.color = '#04ADFF';
			intervalID = runTimer(intervalID);

			// Disable the request again button at the beginning 60s
			setTimeout(() => {
				phoneVerifyRequestAgainButton.classList.remove('disable-button')
			}, 60000);

			// Send SMS request to Vonage
			let phoneNumber = phoneNumberField.value as string;
			phoneNumber = phoneNumber.replace('/ /g', '', ) as string;
			// console.log('before request sms');
			jQuery.ajax({
				url: (window as any).mi_ajax_url,
				type: "POST",
				data:{action:'request_send_sms', phoneNumber},
				success: function(data){
					// console.log("From SMS");
					// console.log(data);
					smsRequest.setAttribute('value', data);
				}
			});
		})
	}

	// Event listener for handling cancel SMS request and create a new SMS request
	if (phoneVerifyRequestAgainButton) {
		listenForClick(phoneVerifyRequestAgainButton, () => {
			// timer countdown
			clearInterval(intervalID);
			phoneVerifyTimer.style.color = '#04ADFF';
			intervalID = runTimer(intervalID);

			// Disable the request again button at the beginning 60s
			phoneVerifyRequestAgainButton.classList.add('disable-button')
			setTimeout(() => {
				phoneVerifyRequestAgainButton.classList.remove('disable-button')
			}, 60000);

			// Cancel SMS request and create a new request
			let phoneNumber = phoneNumberField.value as string;
			phoneNumber = phoneNumber.replace('/ /g', '', ) as string;
			let smsRequestID = smsRequest.value;
			// console.log('try to cancel');
			jQuery.ajax({
				url: (window as any).mi_ajax_url,
				type: "POST",
				data:{action:'cancel_then_request_send_sms', phoneNumber, smsRequestID},
				success: function(data){
					// console.log("From SMS");
					// console.log(data);
					smsRequest.setAttribute('value', data);
				}
			});
		})
	}
}

/*--------------------------------------------------------------------------
*  Disable pointer events for contract preview (except scrolling)
* -------------------------------------------------------------------------*/
export function disablePointerExceptScroll() {
	// For Create Listing Contract Preview
	const createListingContractPreviewWrapper = document.querySelector('#create-listing-contract-preview') as HTMLElement;
	const createListingContractPreview = document.querySelector('#create-listing-contract') as HTMLElement;

	if(createListingContractPreviewWrapper) {
		createListingContractPreview.addEventListener('mousedown', function(e) {
			this.style.pointerEvents = "none";
		}, false);
		createListingContractPreviewWrapper.addEventListener('mouseup', function(e) {
			createListingContractPreview.style.pointerEvents = "all";
		}, false);
	}

	// For Schedule Tour Contract Preview
	const scheduleTourContractPreviewWrapper = document.querySelector('#schedule_tour_p3') as HTMLElement;
	const scheduleTourContractPreview = document.querySelector('#schedule_tour_agreement') as HTMLElement; 

	if(scheduleTourContractPreviewWrapper) {
		scheduleTourContractPreview.addEventListener('mousedown', function(e) {
			this.style.pointerEvents = "none";
		}, false);
		scheduleTourContractPreviewWrapper.addEventListener('mouseup', function(e) {
			scheduleTourContractPreview.style.pointerEvents = "all";
		}, false);
	}

	

}